import React, { useEffect, useState, cloneElement, isValidElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { checkAuthenticated, load_user } from './actions/auth';
import Profile from './components/Profile';
import SignInModal from './components/SignInModal';

const Layout = ({ checkAuthenticated, load_user, children }) => {
  const [profileTrigger, setProfileTrigger] = useState(false);
  const [signInOpen, setSignInOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuthenticated();
    load_user();
  }, [checkAuthenticated, load_user]);

  useEffect(() => {
    if (location.state?.signIn) {
      setSignInOpen(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  const openSignIn = () => setSignInOpen(true);

  const content = isValidElement(children)
    ? cloneElement(children, { onSignIn: openSignIn })
    : children;

  return (
    <div className="landing-layout">
      <Profile trigger={profileTrigger} setTrigger={setProfileTrigger} />
      <SignInModal open={signInOpen} onClose={() => setSignInOpen(false)} />
      {content}
    </div>
  );
};

export default connect(null, { checkAuthenticated, load_user })(Layout);
